import React, { Component } from 'react';
import IndexLicitaciones from '../index/IndexLicitaciones'; 

class Licitaciones extends Component{ 
	componentDidMount(){
	window.startx();
  }
	render(){ 
		return (
			<div id="main" className="wrapper style1">
				<div className="container">
					<header className="major">
						<h2>Licitaciones</h2>
					</header>
					<h3 className="sub-title">
						Licitaciones del Ejercicio 2026.
					</h3>
					<div className="container">
						<div className="row">
							<div className="tabla col-12">
								<div className=" justificacion col-12">
									<div id="accordion">
										{this._renderCardLic2()}
									</div>
								</div>
							</div>
						</div>
					</div>
					<h3 className="sub-title">
						Licitaciones de Ejercicios Anteriores.
					</h3>

					<div className="container">
						<div className="row">
							<div className="tabla col-12">
								<div className=" justificacion col-12">
									<div id="accordion">
										{this._renderCardLic()}
									</div>
								</div>
							</div>
						</div>
					</div>
					
					{/*<div className="container">
						<div className="row">
							<div className="tabla col-12">
								<div className=" justificacion col-12">
									<div id="accordion">
										<div className="card">
											<div className="card-header titulo" id="headingOne">
												<h5 className="mb-0">
													<button className="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
														Licitaciones 2019
													</button>
												</h5>
											</div>

											<div id="collapseOne" className="collapse fondo" aria-labelledby="headingOne" data-parent="#accordion">
												<div className="card-body collCont">
													<div class="container">
														<div class="panel-group">
															<div class="panel panel-default">
																<div class="panel-heading">
																	<h4 class="panel-title">
																		<a data-toggle="collapse" href="#collapse1">MD-02-06</a>
																	</h4>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>

										</div>
									</div>
								</div>
							</div>
						</div>
					</div>*/}


				</div>    
			</div>                         
		); 
	} 

	_renderCardLic = (label) => {
    const arr = IndexLicitaciones.licitaciones;
    return arr.map((data, j) => {  
      return (       
        <div className="card">
					<div className="card-header titulo" id={data.id}>
						<h5 className="mb-0">
							<button className="btn btn-link collapsed" data-toggle="collapse" data-target={"#collapse"+data.id} aria-expanded="false" aria-controls={"collapse"+data.id}>
							{data.numeroLicitacion}
							</button>
						</h5>
					</div>
					<div id={"collapse"+data.id} className="collapse fondo" aria-labelledby={"heading"+data.id} data-parent="#accordion">
						<div className="card-body">
							<ul className="espacios" style={{display: data.base === ""?"none":"block" }}><a href={data.base} target="blank">Bases</a></ul>
							<ul className="espacios" style={{display: data.aclaracion === ""?"none":"block" }}><a href={data.aclaracion} target="blank">Junta de Aclaraciones</a></ul>
							<ul className="espacios" style={{display: data.propuesta === ""?"none":"block" }}><a href={data.propuesta} target="blank">Presentación y Apertura de propuestas</a></ul>
							<ul className="espacios" style={{display: data.fallo === ""?"none":"block" }}><a href={data.fallo} target="blank">Fallo</a></ul>
							<ul className="espacios" style={{display: data.anulacion === ""?"none":"block" }}><a href={data.anulacion} target="blank">Acta de Anulación</a></ul>
							<ul className="espacios" style={{display: data.administrativa === ""?"none":"block" }}><a href={data.administrativa} target="blank">Acta Administrativa</a></ul>
						</div>
					</div>
				</div>
      );
    });
  };
  _renderCardLic2 = (label) => {
    const arr = IndexLicitaciones.licitaciones2;
	
    return arr.map((data, j) => {  
      return (       
        <div className="card">
					<div className="card-header titulo" id={data.id}>
						<h5 className="mb-0">
							<button className="btn btn-link collapsed" data-toggle="collapse" data-target={"#collapse"+data.id} aria-expanded="false" aria-controls={"collapse"+data.id}>
							{data.numeroLicitacion}
							</button>
						</h5>
					</div>
					<div id={"collapse"+data.id} className="collapse fondo" aria-labelledby={"heading"+data.id} data-parent="#accordion">
						<div className="card-body">
							<ul className="espacios" style={{display: data.convocatoria === ""?"none":"block" }}><a href={data.convocatoria} target="blank">Convocatoria</a></ul>
							<ul className="espacios" style={{display: data.base === ""?"none":"block" }}><a href={data.base} target="blank">Bases</a></ul>
							<ul className="espacios" style={{display: data.aclaracion === ""?"none":"block" }}><a href={data.aclaracion} target="blank">Junta de Aclaraciones</a></ul>
							<ul className="espacios" style={{display: data.propuesta === ""?"none":"block" }}><a href={data.propuesta} target="blank">Presentación y Apertura de propuestas</a></ul>
							<ul className="espacios" style={{display: data.fallo === ""?"none":"block" }}><a href={data.fallo} target="blank">Fallo</a></ul>
							<ul className="espacios" style={{display: data.anulacion === ""?"none":"block" }}><a href={data.anulacion} target="blank">Acta de Anulación</a></ul>
							<ul className="espacios" style={{display: data.administrativa === ""?"none":"block" }}><a href={data.administrativa} target="blank">Acta Administrativa</a></ul>
						</div>
					</div>
				</div>
      );
    });
  }
}
	
export default Licitaciones;